module.exports = __webpack_public_path__ + "img/parteneri.aafb4bfc.svg";